import parseISO from "date-fns/parseISO";

export const ensureUTC = (dateString) => {
  // Function meant to take non standardize string and add UTC timezone to string if not instring already
  // It should fail if the string isn't meant to be in UTC, the backend should never return localized dates, just timezone-naive or UTC
  let isoString = dateString;
  if (
    !(
      isoString.endsWith("Z") ||
      isoString.endsWith("+00") ||
      isoString.endsWith("+00:00") ||
      isoString.endsWith("UTC")
    )
  ) {
    isoString += "Z";
  }

  return parseISO(isoString);
};

export function parseUnknownDate(input) {
  // already a Date object
  if (input instanceof Date) return input;

  // numeric input (string or number)
  if (typeof input === "number" || /^[0-9.]+$/.test(String(input))) {
    const num = Number(input);
    if (isNaN(num)) return null;

    // Detect if it's in seconds (10 digits) or milliseconds (13 digits)
    // If it's a float like 1763623708.164586 → treat as seconds
    const isSeconds = num < 1e12;

    const ms = isSeconds ? num * 1000 : num;
    return new Date(ms);
  }

  // Otherwise treat as ISO string
  const date = new Date(input);
  return isNaN(date.getTime()) ? null : date;
}
